import {
  shape, params, string, number, arrayOf, alias, extend
} from '@thd-nucleus/data-sources';
import { dataModel as productPodDataModel } from '@thd-olt-component-react/product-pod/src/components/dataModel';

const Media = shape({
  image: shape({
    url: string()
  }).client(),
  images: arrayOf(shape({
    url: string(),
    type: string(),
    subType: string(),
    sizes: arrayOf(string())
  }))
});

const Product = extend({
  itemId: string(),
  dataSources: string(),
  identifiers: shape({
    brandName: string(),
    itemId: string(),
  }),
  media: Media
}, productPodDataModel.product);

const WrappedProduct = shape({
  product: shape(Product)
});

const Bundle = shape({
  categories: arrayOf(shape({
    category: string(),
    itemIds: arrayOf(string())
  })),

  products: arrayOf(WrappedProduct)
});

export const dataModel = {
  product: alias('product').params({ itemId: string().isRequired(), dataSource: string() }).shape({
    itemId: string(),
    dataSources: string(),
    identifiers: shape({
      sampleId: string(),
      itemId: string()
    }),
  }),

  products: params({ itemIds: arrayOf(string().isRequired()).isRequired() }).arrayOf(shape({
    itemId: string(),
    dataSources: string(),
    media: Media
  })),
  dynamicRecs: params({ itemId: string().isRequired(), storeId: string() }).shape({
    irg: params({ maxItems: number() }).shape({
      collection: Bundle,
      accessories: Bundle,
      coordinatingItems: Bundle
    })
  })
};
